import { WebLayout } from "@src/components/web/WebLayout.web";
import { Slot, Stack } from "expo-router";

export default function ContactsWebLayout() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        <Slot />
      </WebLayout>
    </>
  );
}
